import { render, staticRenderFns } from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=template&id=85d683b0&scoped=true&"
import script from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=script&lang=js&"
export * from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=script&lang=js&"
import style0 from "./Cadastro-Usuarios-Adicionar-Escola.vue?vue&type=style&index=0&id=85d683b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d683b0",
  null
  
)

component.options.__file = "Cadastro-Usuarios-Adicionar-Escola.vue"
export default component.exports